var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowsUpDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_785_16665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.4618 10.8091C11.4997 10.9005 11.5096 11.001 11.4904 11.098C11.4711 11.1951 11.4236 11.2842 11.3537 11.3541L8.35366 14.3541C8.30722 14.4006 8.25207 14.4375 8.19138 14.4627C8.13068 14.4878 8.06561 14.5008 7.99991 14.5008C7.9342 14.5008 7.86913 14.4878 7.80844 14.4627C7.74774 14.4375 7.69259 14.4006 7.64616 14.3541L4.64616 11.3541C4.57615 11.2842 4.52847 11.1951 4.50914 11.098C4.48982 11.001 4.49972 10.9004 4.53759 10.809C4.57547 10.7176 4.63962 10.6395 4.72191 10.5845C4.80421 10.5296 4.90096 10.5003 4.99991 10.5004H10.9999C11.0988 10.5004 11.1955 10.5298 11.2777 10.5847C11.3599 10.6397 11.424 10.7178 11.4618 10.8091ZM4.99991 5.50039H10.9999C11.0989 5.50047 11.1956 5.47119 11.2779 5.41625C11.3602 5.36132 11.4243 5.2832 11.4622 5.19179C11.5001 5.10038 11.51 4.99978 11.4907 4.90274C11.4713 4.8057 11.4237 4.71657 11.3537 4.64664L8.35366 1.64664C8.30722 1.60016 8.25207 1.56328 8.19138 1.53811C8.13068 1.51295 8.06561 1.5 7.99991 1.5C7.9342 1.5 7.86913 1.51295 7.80844 1.53811C7.74774 1.56328 7.69259 1.60016 7.64616 1.64664L4.64616 4.64664C4.57615 4.71657 4.52847 4.8057 4.50914 4.90274C4.48982 4.99978 4.49972 5.10038 4.53759 5.19179C4.57547 5.2832 4.63962 5.36132 4.72191 5.41625C4.80421 5.47119 4.90096 5.50047 4.99991 5.50039Z",
    fill: "#CDCED6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_785_16665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsUpDown);
export default __webpack_public_path__ + "static/media/arrows-up-down.8c83922ba68a9d06b0edb1c6c456231a.svg";
export { ForwardRef as ReactComponent };